import "./styles/App.css";
import SignUpPage from "./pages/SignUpPage.js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage.js";
import Homepage from "./pages/Homepage.js";
import NewCodebase from "./components/codebase/NewCodebase";
import CodeEditorPage from "./components/editor/CodeEditorPage";
import ViewCodebase from "./components/codebase/ViewCodebase";
import PasswordResetRequest from "./pages/PasswordResetRequest.js";
import NewPassword from "./pages/NewPassword.js";
import { ChatProvider } from "./components/editor/ChatContext.js";
import ProfilePage from "./components/profile/ProfilePage.jsx";
import ContactPage from "./components/contact/ContactPage.jsx";
import PrivacyPage from "./pages/PrivacyPage.jsx";
import TermsPage from "./pages/TermsPage.jsx";
import SecurityPage from "./pages/SecurityPage.jsx";
import { UnsavedChangesProvider } from "./components/editor/UnsavedChangesContext.js";
import PrivateRoute from "./routes/PrivateRoute.js";

function App() {
  return (
    <UnsavedChangesProvider>
      <ChatProvider>
        <Router>
          <Routes>
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/reset-password-request"
              element={<PasswordResetRequest />}
            />
            <Route path="/reset-password" element={<NewPassword />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/security" element={<SecurityPage />} />
            <Route path="/codebase/new" element={<NewCodebase />} />
            <Route path="/codebase/view/:id" element={<ViewCodebase />} />
            <Route element={<PrivateRoute />}>
              <Route
                path="/codebase/new/:section"
                element={<CodeEditorPage />}
              />
              <Route
                path="/codebase/edit/:codebaseId/:section"
                element={<CodeEditorPage />}
              />
              <Route path="/profile" element={<ProfilePage />} />
            </Route>
            <Route path="/*" element={<Homepage />} />
          </Routes>
        </Router>
      </ChatProvider>
    </UnsavedChangesProvider>
  );
}

export default App;
